import angular from 'angular'
import './withdrawals.service'

angular
  .module('admin.withdrawals', ['admin.withdrawals.service'])
  .controller('WithdrawalsAdminCtrl', WithdrawalsAdminCtrl)

/** @ngInject */
function WithdrawalsAdminCtrl($scope, UsersService, WithdrawalsService) {
  var vm = this
  vm.items = []
  vm.perPage = 25
  vm.duration = 24

  vm.userId = null

  vm.perPage = 25
  vm.sortType = 'n-asc'
  vm.sortReverse = false
  vm.sortType2 = 'ts-p-desc'
  vm.sortReverse2 = false
  vm.sortType3 = 'ts-p-desc'
  vm.sortReverse3 = false

  function reloadPaginationPrevious() {
    vm.totalItemsPrevious = 0
    vm.oldPagePrevious = 0
    vm.currentPagePrevious = 25
    vm.firstPrevious = true
    vm.totalItemsPrevious = 0
    vm.paginationPrevious = {
      current: 1,
    }
  }

  function reloadPaginationOpen() {
    vm.totalItemsOpen = 0
    vm.oldPageOpen = 0
    vm.currentPageOpen = 25
    vm.firstOpen = true
    vm.totalItemsOpen = 0
    vm.paginationOpen = {
      current: 1,
    }
  }

  function reloadPaginationUser() {
    vm.totalItemsUser = 0
    vm.oldPageUser = 0
    vm.currentPageUser = 25
    vm.firstUser = true
    vm.totalItemsUser = 0
    vm.paginationUser = {
      current: 1,
    }
  }

  function reloadPaginationSearchUser() {
    vm.totalItemsSearchUser = 0
    vm.oldPageSearchUser = 0
    vm.currentPageSearchUser = 25
    vm.firstSearchUser = true
    vm.totalItemsSearchUser = 0
    vm.paginationSearchUser = {
      current: 1,
    }
  }

  reloadPaginationPrevious()
  reloadPaginationOpen()
  reloadPaginationUser()
  reloadPaginationSearchUser()
  loadPrevious(1)
  loadOpen(1)
  loadUser(1)

  var tab = localStorage.getItem('withdrawals')
  if (tab !== null) {
    if (tab === 'previous') {
      $('#open').removeClass('active')
      $('#user').removeClass('active')
      $('#previous').addClass('active')
      $('#previoustab').addClass('active')
    } else if (tab === 'open') {
      $('#previous').removeClass('active')
      $('#user').removeClass('active')
      $('#open').addClass('active')
      $('#opentab').addClass('active')
    } else if (tab === 'user') {
      $('#open').removeClass('active')
      $('#previous').removeClass('active')
      $('#user').addClass('active')
      $('#usertab').addClass('active')
    }
  } else {
    $('#previous').addClass('active')
    $('#previoustab').addClass('active')
  }

  vm.tabPrevious = function () {
    $('#open').removeClass('active')
    $('#user').removeClass('active')
    $('#previous').addClass('active')
    localStorage.setItem('withdrawals', 'previous')
  }

  vm.tabOpen = function () {
    $('#previous').removeClass('active')
    $('#user').removeClass('active')
    $('#open').addClass('active')
    localStorage.setItem('withdrawals', 'open')
  }

  vm.tabUser = function () {
    $('#previous').removeClass('active')
    $('#open').removeClass('active')
    $('#user').addClass('active')
    localStorage.setItem('withdrawals', 'user')
  }

  function loadPrevious(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationPrevious.current = 1
    }
    if (!vm.firstPrevious) {
      vm.currentPagePrevious = pageNumber * 25
      vm.oldPagePrevious = vm.currentPagePrevious - 25
    } else {
      vm.firstPrevious = false
    }

    WithdrawalsService.list(vm.oldPagePrevious, 25, 45 * 24 * 2).then(function (result) {
      if (vm.totalItemsPrevious === 0) {
        vm.totalItemsPrevious = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.itemsPrevious = result.results
    })
  }

  function loadOpen(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationOpen.current = 1
    }
    if (!vm.firstOpen) {
      vm.currentPageOpen = pageNumber * 25
      vm.oldPageOpen = vm.currentPageOpen - 25
    } else {
      vm.firstOpen = false
    }

    WithdrawalsService.listPending(vm.oldPageOpen, 25, 45 * 24 * 2).then(function (result) {
      if (vm.totalItemsOpen === 0) {
        vm.totalItemsOpen = result.ct
      }

      for (var i = 0; i < result.results.length; i++) {
        result.results[i].check = false
        if (result.results[i]['ts']) {
          result.results[i]['ts'] = new Date(
            parseInt(
              result.results[i]['ts']
                .toString()
                .substring(0, result.results[i]['ts'].toString().length - 3),
            ),
          )
        }
        if (result.results[i]['ts-m']) {
          result.results[i]['ts-m'] = new Date(
            parseInt(
              result.results[i]['ts-m']
                .toString()
                .substring(0, result.results[i]['ts-m'].toString().length - 3),
            ),
          )
        }
      }
      vm.itemsOpen = result.results
      vm.total = result.total
    })
  }

  function loadUser(pageNumber) {
    if (pageNumber === 1) {
      vm.paginationUser.current = 1
    }
    if (!vm.firstUser) {
      vm.currentPageUser = pageNumber * 25
      vm.oldPageUser = vm.currentPageUser - 25
    } else {
      vm.firstUser = false
    }

    WithdrawalsService.listUserWithdrals(vm.userId, vm.oldPageUser, 25, 45 * 24 * 2).then(
      function (result) {
        if (vm.totalItemsUser === 0) {
          vm.totalItemsUser = result.ct
        }

        for (var i = 0; i < result.results.length; i++) {
          result.results[i].check = false
          if (result.results[i]['ts']) {
            result.results[i]['ts'] = new Date(
              parseInt(
                result.results[i]['ts']
                  .toString()
                  .substring(0, result.results[i]['ts'].toString().length - 3),
              ),
            )
          }
          if (result.results[i]['ts-m']) {
            result.results[i]['ts-m'] = new Date(
              parseInt(
                result.results[i]['ts-m']
                  .toString()
                  .substring(0, result.results[i]['ts-m'].toString().length - 3),
              ),
            )
          }
        }
        vm.itemsUser = result.results
      },
    )
  }

  loadPrevious(1)
  loadOpen(1)
  loadUser(1)

  vm.loadPrevious = function () {
    reloadPaginationPrevious()
    loadPrevious(1)
  }

  vm.loadOpen = function () {
    reloadPaginationOpen()
    loadOpen(1)
  }

  vm.loadUser = function () {
    reloadPaginationUser()
    loadUser(1)
  }

  vm.pageChangedPrevious = function (newPage) {
    loadPrevious(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChangedOpen = function (newPage) {
    loadOpen(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChangedUser = function (newPage) {
    loadUser(newPage)
    $('html, body').animate({ scrollTop: 0 }, 0)
  }

  vm.pageChangedSearchUser = function (newPage) {
    loadUsers(newPage)
  }

  vm.approveWithdrawal = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          WithdrawalsService.approve(id).then(function () {
            loadOpen(1)
            loadUser(1)
            loadPrevious(1)
          })
        }
      },
    )
  }

  vm.approveAllWithdrawal = function () {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          WithdrawalsService.approveAll().then(function () {
            loadOpen(1)
            loadUser(1)
            loadPrevious(1)
          })
        }
      },
    )
  }

  vm.changeAmount = function (item) {
    $('#myModal').modal('show')
    vm.item = item
  }

  vm.saveAmount = function () {
    WithdrawalsService.changeAmount(vm.item.id, { amt: vm.newAmount }).then(function () {
      $('#myModal').modal('hide')
      loadOpen(1)
      loadUser(1)
      loadPrevious(1)
    })
  }

  vm.deleteWithdrawals = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          WithdrawalsService.remove(id).then(function () {
            loadOpen(1)
            loadUser(1)
            loadPrevious(1)
          })
        }
      },
    )
  }

  vm.allWithdrawal = function (item) {
    vm.userId = item['id-u']
    vm.loadUser()
    vm.tabUser()
    $('#opentab').removeClass('active')
    $('#previoustab').removeClass('active')
    $('#usertab').addClass('active')
  }

  vm.modalSearchUser = function () {
    $('#myModalSearchUser').modal('show')
  }

  vm.search = ''

  vm.options = [
    {
      id: 1,
      name: 'Username',
    },
    {
      id: 2,
      name: 'Email',
    },
    {
      id: 3,
      name: 'ID',
    },
  ]
  vm.option = vm.options[0].id

  vm.searchUsers = function () {
    reloadPaginationSearchUser()
    loadUsers(1)
  }

  vm.addUser = function (item) {
    vm.userId = item.id
    vm.loadUser()
    $('#myModalSearchUser').modal('hide')
  }

  function loadUsers(pageNumber) {
    if (vm.option !== 3) {
      if (
        vm.search === undefined ||
        vm.search === null ||
        vm.search === '' ||
        vm.search.length < 3
      ) {
        return
      }
    } else {
      if (vm.search === undefined || vm.search === null || vm.search === '') {
        return
      }
    }

    if (pageNumber === 1) {
      vm.paginationSearchUser.current = 1
    }
    if (!vm.firstSearchUser) {
      vm.currentPageSearchUser = pageNumber * 10
      vm.oldPageSearchUser = vm.currentPageSearchUser - 10
    } else {
      vm.firstSearchUser = false
    }
    vm.items = []
    if (vm.option === 1) {
      UsersService.search(vm.search, '', vm.oldPageSearchUser, 10).then(function (result) {
        if (vm.totalItemsSearchUser === 0) {
          vm.totalItemsSearchUser = result.ct
        }
        vm.users = result.results
        vm.users.map(function (item) {
          item.added = false
        })
      })
    } else if (vm.option === 2) {
      UsersService.searchEmail(vm.search, '', vm.oldPagSearchUser, 10).then(function (result) {
        if (vm.totalItemsSearchUser === 0) {
          vm.totalItemsSearchUser = result.ct
        }
        vm.users = result.results
        vm.users.map(function (item) {
          item.added = false
        })
      })
    } else {
      UsersService.get(vm.search).then(function (result) {
        if (vm.totalItemsSearchUser === 0) {
          vm.totalItemsSearchUser = 1
        }
        vm.users = [result.results]
        vm.users.map(function (item) {
          item.added = false
        })
      })
    }
  }
}
